import { render } from "./_icon-pdf.vue?vue&type=template&id=3f1a715a"
import script from "./_icon-pdf.vue?vue&type=script&lang=js"
export * from "./_icon-pdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__